import React from "react";
import { Link } from "react-router-dom";
import Truncatetext from "./Truncatetext";
import { FaLink, FaGithub } from "react-icons/fa";
import { motion } from "framer-motion";

const Project = ({ work }) => {
  const images = work.image;
  const firstImage = images[0];
  const secondImage = images[1];
  const tags = work.Technologies.slice(1, 5);
  console.log("slug", work.slug);
  return (
    <>
      <motion.div
        class="project"
        whileInView={{ y: [100, 50, 0], opacity: [0, 0, 1] }}
        transition={{ duration: 0.7 }}
      >
        <Link to={`/work-detail/${work && work.slug}`} class="p-text" href="">
          <img
            src={firstImage.image}
            alt={work.title}
            className="w-full h-[90%] object-contain"
            lazyload
          />
          <div class="project__stacks">
            {tags && tags.map((tag) => <p className="p-text"> {tag.name}</p>)}
          </div>
          <div class="project__detail">
            <p class="project__name">{work.title}</p>
            <p class="project__description">
              <Truncatetext text={work && work.description} maxLength={50} />
            </p>
          </div>
        </Link>
        <div class="project-links">
          <a href={work.project_link}>
            Live <FaLink />
          </a>
          <a href={work.code_link}>
            Code <FaGithub />
          </a>
        </div>
      </motion.div>
    </>
  );
};

export default Project;
